<template>
  <div :class="[
      span ? `ee-col-${span}` : '',
      offset ? `ee-col-offset-${offset}` : '',
      pull ? `ee-col-pull-${pull}` : '',
      push ? `ee-col-push-${push}` : '',
    ]"
    :style="style"
  >
    <slot></slot>
  </div>
</template>
<script>
  export default {
    compName: 'ee-col',
    props: {
      span: Number,
      offset: Number,
      pull: Number,
      push: Number
    },
    computed: {
      style () {
        const gutter = this.$parent.gutter
        const ret = {}
        if (gutter) {
          ret.paddingLeft = ret.paddingRight = `${gutter / 2}px`
        }
        return ret
      }
    }
  }
</script>
<style src="../style/col.css"></style>



// WEBPACK FOOTER //
// src/packages/col/Col.vue?8675d364